import React from 'react';
import styles from './styles.module.css';
import { CourseColor } from '../../../config/course';
import { CorrectAnswer } from '../../../lib/domSlide';
import { LongWordsLessonSlide } from '../../../config/course';
import SlidePracticeBackground from '../../atoms/SlidePracticeBackground';
import FontTitle from '../../atoms/FontTitle';
import Textbox from '../../atoms/Textbox';
import { PrimaryButton } from '../../atoms/Button';

export type SlidePracticeLongWordsProps = {
    pageIndex: number;
    slideColor: CourseColor;
    isCheckingAnswers: boolean;
    myAnswers: Array<CorrectAnswer>;
    updateMyAnswersWithIndex: (index:number) => (e: React.ChangeEvent<HTMLInputElement>) => void;
    updateIsCheckingAnswersTrue: (e: React.MouseEvent<HTMLButtonElement>) => void;
} & Omit<LongWordsLessonSlide, 'type'>;


// 2023.10.29 by t.nakata
// 長い単語を記憶する演習
// 英単語記憶コースにおいて6個の長い単語を覚えるためのレイアウト
// 表示問題数が6個以外の場合は調整が必要
const SlidePracticeLongWords : React.FC<SlidePracticeLongWordsProps> = ({
    pageIndex,
    slideColor,
    memorizationTitle,
    recallTitle,
    resultTitle = '結果を判定します',
    hasMemorizationSlide = false,
    correctAnswers,
    myAnswers,
    isCheckingAnswers,

    updateMyAnswersWithIndex,
    updateIsCheckingAnswersTrue,
}) => {
    const domSlideClass = styles['dom-slide'];              // スライド領域
    let titleClass = styles['dom-slide-title'];             // タイトル設定
    let answerAreaClass = styles['dom-slide-answerarea'];   // 問題・回答エリア設定
    let itemGroupClass = styles['item-group'];            // 問題 ラベルと回答欄を合わせたエリア
    let itemLabelClass = styles['item-label'];            // 問題ラベル設定 
    let answerColumnClass = styles['input-item'];           // 問題・回答欄設定
    let buttonAreaClass = styles['button-area'];            // ボタン設定

    // 問題数が6
    if (correctAnswers.length === 6) {
        titleClass += ' ' + styles['six-questions'];
        answerAreaClass += ' '+ styles['six-questions'];
        buttonAreaClass += ' '+ styles['six-questions'];
    }

    // 回答欄のmaxLengthを取得(正答の最大文字数+2)
    let answerMaxLength = 1;        // 最初は仮に1を設定
    for (let i = 0; i < correctAnswers.length; i++) {
        for (let j = 0; j < correctAnswers[i].words.length; j++) {
            if (answerMaxLength < correctAnswers[i].words[j].length) answerMaxLength = correctAnswers[i].words[j].length;
        }
    }
    answerMaxLength += 2;

    // 結果画面
    if (pageIndex === 1 && isCheckingAnswers) {
        answerAreaClass += ' '+ styles['result'];
        answerColumnClass += ' ' + styles['result'];
        itemGroupClass += ' ' + styles['result'];
    }

    return (
        <div className={ styles['slide-practice-long-words-table'] }>
            <SlidePracticeBackground bgColor={slideColor} className={domSlideClass}>
                {/* 記憶画面 */}
                {(hasMemorizationSlide && pageIndex === 0) &&
                <div className={styles['dom-slide-area']}>
                    <FontTitle className={titleClass}>{memorizationTitle}</FontTitle>
                    <div className={styles['dom-slide-content']}>
                        <div className={answerAreaClass}>
                            {correctAnswers.map((correctAnswer, idx) => {
                                return (
                                    <div className={itemGroupClass} key={idx}>
                                        <label className={itemLabelClass}>{correctAnswer.label}</label>
                                        <span className={answerColumnClass}>{correctAnswer.words[0]}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                }

                {/* 回答画面 */}
                {((!hasMemorizationSlide || pageIndex === 1) && !isCheckingAnswers) &&
                <div className={styles['dom-slide-area']}>
                    <FontTitle className={titleClass}>{recallTitle}</FontTitle>
                    <div className={styles['dom-slide-content']}>
                        <div className={answerAreaClass}>
                            {correctAnswers.map((correctAnswer, idx) => {
                                return (
                                    <div className={itemGroupClass} key={idx}>
                                        <label className={itemLabelClass}>{correctAnswer.label}</label>
                                        <Textbox
                                        key={idx}
                                        className={answerColumnClass}
                                        value={myAnswers[idx]?.words[0] || []}
                                        onChange={updateMyAnswersWithIndex(idx)}
                                        maxLength={answerMaxLength}
                                    />
                                    </div>
                                );
                            })}
                        </div>
                        <div className={buttonAreaClass}>
                            <PrimaryButton className={styles['button']} onClick={updateIsCheckingAnswersTrue}>答え合わせする</PrimaryButton>
                        </div>
                    </div>
                </div>
                }

                {/* 結果画面 */}
                {((!hasMemorizationSlide || pageIndex === 1) && isCheckingAnswers) &&
                <div className={styles['dom-slide-area']}>
                    <FontTitle className={titleClass}>{resultTitle}</FontTitle>
                    <div className={styles['dom-slide-content']}>
                        <div className={answerAreaClass}>
                            {correctAnswers.map((correctAnswer, idx) => {
                                const value = myAnswers[idx]?.words[0] || '';
                                const resultClass = (correctAnswer.words.includes(value))? styles['correct'] : styles['incorrect'];
                                return (
                                    <React.Fragment>
                                        <div className={itemGroupClass} key={idx}>
                                            <label className={itemLabelClass}>{correctAnswer.label}</label>
                                            <span className={answerColumnClass+' '+resultClass}>{myAnswers[idx]?.words[0] || ''}</span>
                                        </div>
                                        <div className={styles['correct-answer']}>{correctAnswer.words[0]}</div>
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                </div>
                }
            </SlidePracticeBackground>
        </div>
    );
};

export default SlidePracticeLongWords;
